"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrength = void 0;
var zxcvbn = require("zxcvbn");
var getStrength = function (pass) {
    if (!pass) {
        return {
            text: 'userfront/forgotPasswordView/strength',
            className: 'default',
            level: 0
        };
    }
    else if (pass.length < 8) {
        return {
            text: 'userfront/forgotPasswordView/tooShort',
            className: 'invalid',
            level: 1
        };
    }
    else if (!pass.match(/\d+/g)) {
        return {
            text: 'userfront/forgotPasswordView/requiresNumber',
            className: 'invalid',
            level: 1
        };
    }
    else if (!pass.match(/[A-Z]+/g)) {
        return {
            text: 'userfront/forgotPasswordView/requiresCapital',
            className: 'invalid',
            level: 1
        };
    }
    else if (!pass.match(/[a-z]+/g)) {
        return {
            text: 'userfront/forgotPasswordView/requiresLowercase',
            className: 'invalid',
            level: 1
        };
    }
    else {
        var result = zxcvbn(pass);
        if (result.score > 3) {
            return {
                text: 'userfront/forgotPasswordView/strong',
                className: 'strong',
                level: 4
            };
        }
        else if (result.score === 3) {
            return {
                text: 'userfront/forgotPasswordView/good',
                className: 'good',
                level: 3
            };
        }
        else if (result.score === 2) {
            return {
                text: 'userfront/forgotPasswordView/weak',
                className: 'weak',
                level: 2
            };
        }
        return {
            text: 'userfront/forgotPasswordView/tooWeak',
            className: 'invalid',
            level: 1
        };
    }
};
exports.getStrength = getStrength;
